import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from './Component';
/**
 * The shadow component enables shadows for an entity and its children.
 * Receiving shadows from surrounding objects and casting shadows
 * onto other objects may (and often should) be enabled independently.
 *
 * Without this component, an entity will not cast nor receive shadows.
 *
 * @see https://aframe.io/docs/1.3.0/components/shadow.html
 */

export var Shadow = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Shadow, _Component);

  function Shadow() {
    return _Component.apply(this, arguments) || this;
  }

  return Shadow;
}(Component);